import React, { Suspense, useState } from 'react';
import { ConfigModel, formatPrice } from '@ibe/services';
import { useMount } from 'react-use';
import { observer } from 'mobx-react';
import { ExternalFormatPrice, ExternalSearchParamsContextProps } from '@ibe/components';
import initI18next from '../Translations/setup';
import { ThgConfigModel } from '../Config/ThgConfigModel';
import '../Theme/Styles/myJourneyModal.scss';
import MyJourneysModal from '../Components/MyJourneys/MyJourneysModal';
import { extendedConfigContext } from '../Config/extendedConfigContext';
import { bootMinimal } from '../Config/minimalConfig';

const MyJourneysModalWidget = observer(
  (props: {
    myJourneysUrl?: string;
    thgConfig: ThgConfigModel;
    configOverrides?: ConfigModel;
    widgetSessionKeyPrefix: ExternalSearchParamsContextProps['widgetSessionKeyPrefix'];
    mode: ExternalSearchParamsContextProps['mode'];
  }) => {
    const { myJourneysUrl, configOverrides, thgConfig, mode } = props;
    const [bootstrappingFinished, setBootstrappingFinished] = useState<boolean>(false);

    useMount(async () => {
      await initI18next(
        thgConfig.baseUrl,
        thgConfig.version,
        configOverrides?.tenant ?? undefined,
        mode
      );
      await bootMinimal(configOverrides, thgConfig);
      setBootstrappingFinished(true);
    });

    return bootstrappingFinished ? (
      <div style={{ backgroundColor: 'transparent' }} id="iso">
        <Suspense fallback={null}>
          <extendedConfigContext.Provider value={thgConfig}>
            <ExternalFormatPrice externalFormatPrice={formatPrice}>
              <MyJourneysModal myJourneysUrl={myJourneysUrl} />
            </ExternalFormatPrice>
          </extendedConfigContext.Provider>
        </Suspense>
      </div>
    ) : (
      <></>
    );
  }
);

export default MyJourneysModalWidget;
